import { render, staticRenderFns } from "./GroupsNew.vue?vue&type=template&id=b22368b4"
import script from "./GroupsNew.vue?vue&type=script&lang=ts"
export * from "./GroupsNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22368b4')) {
      api.createRecord('b22368b4', component.options)
    } else {
      api.reload('b22368b4', component.options)
    }
    module.hot.accept("./GroupsNew.vue?vue&type=template&id=b22368b4", function () {
      api.rerender('b22368b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/GroupsNew.vue"
export default component.exports